import { useState, useEffect, useRef } from 'react';
import { Button, Modal } from "react-bootstrap";
import axios from 'axios';
import CircularProgress from "@mui/material/CircularProgress";
import { Paper, Box, List, ListItem, ListItemButton, ListItemText, IconButton, Drawer } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import BottomTabNavigation from './BottomTabNavigation';
import AddForumOverlay from "./AddForumOverlay";
import Konsensus_Constants from '../constants/index.js'
import DOMPurify from "dompurify";
import he from "he";
import Dialog from '@mui/material/Dialog';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

  let forum_tags = [
    { id: "1", attributes: { name: "General" } },
    { id: "2", attributes: { name: "Trustee" } }
  ];

export default function Vertex() {
  const scrollableDivRef = useRef(null);
  const navigate = useNavigate();
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([]);
  const [id, setId] = useState([]);
  const [email, setEmail] = useState([]);
  const [username, setUsername] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [input_post, setInputPost] = useState('');
  const [forum_title, setForumTitle] = useState('');
  const [showOverlay, setShowOverlay] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [create_discussion, setCreateDiscussion] = useState(false);

  const [chatSessions, setChatSessions] = useState([]);
  const [currentSessionId, setCurrentSessionId] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [sessionToDelete, setSessionToDelete] = useState(null);
  const [clearAllDialogOpen, setClearAllDialogOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const fileInputRef = useRef(null);

  const [cameraOpen, setCameraOpen] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const tags = null;

  const [renderKey, setRenderKey] = useState(0);

  const scrollToRef = (ref) => {
      if (ref.current) {
        ref.current.scrollTop = ref.current.scrollHeight+100;
        ref.scrollTop = ref.current.scrollHeight+100;
        ref.current.scrollIntoView({ behavior: 'smooth' });
        console.log("scrolling to view!");
      }else{
        console.log("not scrolling to view!");
      }
  };

  useEffect(() => {
    if (currentSessionId && id) {
      const savedLoadingState = localStorage.getItem(`gemini_loading_${currentSessionId}_${id}`);
      if (savedLoadingState === 'true') {
        setIsFetching(true);
      }
    }
  }, [currentSessionId, id]);

  useEffect(() => {
    if (currentSessionId && id) {
      if (isFetching) {
        localStorage.setItem(`gemini_loading_${currentSessionId}_${id}`, 'true');
      } else {
        localStorage.removeItem(`gemini_loading_${currentSessionId}_${id}`);
      }
    }
  }, [isFetching, currentSessionId, id]);

  useEffect(() => {
    if (username && messages.length === 1 && messages[0].bot === 'Hello ! 👋, how can I help you today?') {
      setMessages([{
        id: '1',
        bot: `Hello ${username}! 👋 How can I help you today?`,
        fromMe: false
      }]);
    }
  }, [username]);

  const checkLogin = async() => {
    if( window.location.href!='https://app.konsensus.tech/' && window.location.href!='https://app.dev.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/register' && window.location.href!='https://app.accept.konsensus.tech/forgotten_password'){
        try{
            let login_data = await Konsensus_Constants._retrieveDataLocal("login_response");
            let nem = await Konsensus_Constants._retrieveDataLocal("nem");
            setId(login_data.login_response.data.userId);
            setEmail(nem.nem.data.email);
            setUsername(nem.nem.data.username);

            if(login_data.login_response.data) {
                console.log("User ID: " + login_data.login_response.data.userId);
                let res = await fetch(Konsensus_Constants.FORUM_URL + '/api/users/' + login_data.login_response.data.userId + "?include=groups", {
                  headers: { 'Authorization': 'Token ' + login_data.login_response.data.token }
                });

                if (res.status === 200) {
                  const userData = await res.json();

                  // Debug: Log the entire response structure
                  console.log("Full userData response:", userData);
                  console.log("userData.data:", userData.data);
                  console.log("All relationships:", userData.data?.relationships);
                  console.log("Included array:", userData.included);

                  // If groups are only in included, get all groups from there
                  const allIncludedGroups = userData.included?.filter(item => item.type === 'groups') || [];
                  console.log("All groups in included:", allIncludedGroups);

                  // Since we can't determine which groups the user belongs to from relationships,
                  // we need to check if the groups in 'included' are the user's groups
                  // The fact they're included likely means they're associated with the user

                  let isTrustee = false;
                  let isAdmin = false;

                  if (allIncludedGroups.length > 0) {
                    isTrustee = allIncludedGroups.some(group =>
                      group.attributes?.nameSingular === 'Trustee' ||
                      group.attributes?.namePlural === 'Trustees'
                    );

                    isAdmin = allIncludedGroups.some(group =>
                      group.attributes?.nameSingular === 'Admin' ||
                      group.attributes?.namePlural === 'Admins'
                    );

                    // Log group names to debug
                    allIncludedGroups.forEach(group => {
                      console.log(`Group: ${group.attributes?.nameSingular || group.attributes?.namePlural}, ID: ${group.id}`);
                    });
                  }

                  console.log("Is trustee: " + isTrustee + " isAdmin:" + isAdmin);

                  if (isTrustee || isAdmin) {
                    forum_tags = [
                      { id: "1", attributes: { name: "General" } },
                      { id: "2", attributes: { name: "Trustee" } }
                    ];
                  } else {
                    forum_tags = [
                      { id: "1", attributes: { name: "General" } }
                    ];
                  }
                } else {
                  Konsensus_Constants.clear();
                  navigate('/', { state: { message: "Either your login has expired or you haven't confirmed e-mail yet!" } });
                }
            }
        } catch (error) {
          console.error(error);
          navigate('/', { state: { message: "Either your login has expired or you haven't confirmed e-mail yet!" } });
        }
    }
    console.log(window.location.href);
  }

  const ensureHttps = (url) => {
    if (!url) return url;
    if (url.startsWith('/') || url.startsWith('https://') || url.startsWith('data:') || url.startsWith('blob:')) {
      return url;
    }
    if (url.startsWith('http://')) {
      return url.replace('http://', 'https://');
    }
    return url;
  };

  const loadChatSessions = () => {
    try {
      const savedSessions = localStorage.getItem('gemini_chat_sessions_'+id);
      const savedCurrentId = localStorage.getItem('gemini_current_session_id_'+id);

      if (savedSessions) {
        const sessions = JSON.parse(savedSessions);
        setChatSessions(sessions);

        if (savedCurrentId && sessions.find(s => s.id === savedCurrentId)) {
          loadSession(savedCurrentId, sessions);
        } else if (sessions.length > 0) {
          loadSession(sessions[0].id, sessions);
        } else {
          const newSessionId = `gemini_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          setCurrentSessionId(newSessionId);
          setMessages([{ id: '1', bot: 'Hello '+username+'! 👋, how can I help you today?', fromMe: false }]);
        }
      } else {
        const newSessionId = `gemini_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        setCurrentSessionId(newSessionId);
        setMessages([{ id: '1', bot: 'Hello '+username+'! 👋, how can I help you today?', fromMe: false }]);
      }
    } catch (error) {
      console.error('Error loading chat sessions:', error);
      const newSessionId = `gemini_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      setCurrentSessionId(newSessionId);
      setMessages([{ id: '1', bot: 'Hello '+username+'! 👋, how can I help you today?', fromMe: false }]);
    }
  };

  const checkForResponseInLocalStorage = (sessionId) => {
    try {
      const savedSessions = localStorage.getItem('gemini_chat_sessions_'+id);
      if (savedSessions) {
        const sessions = JSON.parse(savedSessions);
        const currentSession = sessions.find(s => s.id === sessionId);
        if (currentSession && currentSession.messages) {
          const lastMsg = currentSession.messages[currentSession.messages.length - 1];

          if (messages.length === 0) {
            return false;
          }

          const currentStateLastMsg = messages[messages.length - 1];

          if (lastMsg && lastMsg.bot && lastMsg.isLoading === false) {
            if (currentStateLastMsg && currentStateLastMsg.isLoading === true &&
                currentStateLastMsg.user === lastMsg.user) {
              console.log('Found matching response in localStorage, updating UI');
              setMessages([...currentSession.messages]);
              setIsFetching(false);
              setRenderKey(prev => prev + 1);
              localStorage.removeItem(`gemini_loading_${sessionId}_${id}`);
              setTimeout(() => scrollToRef(scrollableDivRef), 100);
              return true;
            }
          }
        }
      }
    } catch (error) {
      console.error('Error checking localStorage:', error);
    }
    return false;
  };

  const loadSession = (sessionId, sessions = chatSessions) => {
    const session = sessions.find(s => s.id === sessionId);
    if (session) {
      setCurrentSessionId(sessionId);
      setMessages(session.messages);
      setRenderKey(prev => prev + 1);
      localStorage.setItem('gemini_current_session_id_'+id, sessionId);

      const savedLoadingState = localStorage.getItem(`gemini_loading_${sessionId}_${id}`);

      if (savedLoadingState === 'true') {
        const lastMsg = session.messages[session.messages.length - 1];

        if (lastMsg && (lastMsg.isLoading || (lastMsg.user && !lastMsg.bot))) {
          setIsFetching(true);
          setTimeout(() => {
            checkForResponseInLocalStorage(sessionId);
          }, 100);
        } else {
          localStorage.removeItem(`gemini_loading_${sessionId}_${id}`);
          setIsFetching(false);
        }
      } else {
        setIsFetching(false);
      }

      setTimeout(() => scrollToRef(scrollableDivRef), 100);
    }
  };

  const saveChatSessions = (sessions, currentId = currentSessionId) => {
    try {
      localStorage.setItem('gemini_chat_sessions_'+id, JSON.stringify(sessions));
      if (currentId) {
        localStorage.setItem('gemini_current_session_id_'+id, currentId);
      }
    } catch (error) {
      console.error('Error saving chat sessions:', error);
    }
  };

  const updateCurrentSession = (newMessages) => {
    const sessionExists = chatSessions.find(s => s.id === currentSessionId);

    let updatedSessions;

    if (sessionExists) {
      updatedSessions = chatSessions.map(session => {
        if (session.id === currentSessionId) {
          return {
            ...session,
            messages: newMessages,
            lastMessage: newMessages[newMessages.length - 1]?.user || newMessages[newMessages.length - 1]?.bot || 'New chat',
            updatedAt: new Date().toISOString()
          };
        }
        return session;
      });

      setChatSessions(updatedSessions);
      saveChatSessions(updatedSessions);
    } else {
      const newSession = {
        id: currentSessionId,
        messages: newMessages,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        lastMessage: newMessages[newMessages.length - 1]?.user || newMessages[newMessages.length - 1]?.bot || 'New chat'
      };

      updatedSessions = [newSession, ...chatSessions];
      setChatSessions(updatedSessions);
      saveChatSessions(updatedSessions, currentSessionId);
    }

    try {
      localStorage.setItem('gemini_chat_sessions_'+id, JSON.stringify(updatedSessions));
    } catch (error) {
      console.error('Error force saving to localStorage:', error);
    }
  };

  const createNewChat = () => {
    const newSessionId = `gemini_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    setCurrentSessionId(newSessionId);
    setMessages([{ id: '1', bot: 'Hello '+username+'! 👋, how can I help you today?', fromMe: false }]);
    setIsFetching(false);
    setDrawerOpen(false);
  };

  const deleteSession = (sessionId) => {
    setSessionToDelete(sessionId);
    setDeleteDialogOpen(true);
  };

  const confirmDeleteSession = async () => {
    try {
      await axios.delete(`${Konsensus_Constants.API_URL}/api/chat2/session/${sessionToDelete}`);
    } catch (error) {
      console.log('Server delete failed, continuing with local delete');
    }

    localStorage.removeItem(`gemini_loading_${sessionToDelete}_${id}`);

    const updatedSessions = chatSessions.filter(s => s.id !== sessionToDelete);
    setChatSessions(updatedSessions);
    saveChatSessions(updatedSessions);

    if (sessionToDelete === currentSessionId) {
      if (updatedSessions.length > 0) {
        loadSession(updatedSessions[0].id, updatedSessions);
      } else {
        const newSessionId = `gemini_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        setCurrentSessionId(newSessionId);
        setMessages([{ id: '1', bot: 'Hello '+username+'! 👋, how can I help you today?', fromMe: false }]);
        setIsFetching(false);
      }
    }

    setDeleteDialogOpen(false);
    setSessionToDelete(null);
  };

  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    const newFiles = files.map(file => ({
      file: file,
      name: file.name,
      size: file.size,
      type: file.type,
      id: Math.random().toString(36).substr(2, 9)
    }));
    setUploadedFiles([...uploadedFiles, ...newFiles]);
  };

  const removeFile = (fileId) => {
    setUploadedFiles(uploadedFiles.filter(f => f.id !== fileId));
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  const uploadFilesToServer = async (files) => {
    const formData = new FormData();
    files.forEach((fileObj) => {
      formData.append('files', fileObj.file);
    });
    formData.append('email', email);
    formData.append('sessionId', currentSessionId);

    try {
      const response = await axios.post(
        `${Konsensus_Constants.API_URL}/api/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          timeout: 30000
        }
      );
      return response.data;
    } catch (error) {
      console.error('File upload error details:', error.response || error);
      throw error;
    }
  };

  const clearAllHistory = () => {
    setClearAllDialogOpen(true);
  };

  const confirmClearAllHistory = () => {
    chatSessions.forEach(session => {
      localStorage.removeItem(`gemini_loading_${session.id}_${id}`);
    });

    localStorage.removeItem('gemini_chat_sessions_'+id);
    localStorage.removeItem('gemini_current_session_id_'+id);
    setChatSessions([]);
    setCurrentSessionId(null);
    setMessages([{ id: '1', bot: 'Hello '+username+'! 👋, how can I help you today?', fromMe: false }]);
    setIsFetching(false);
    setDrawerOpen(false);
    setClearAllDialogOpen(false);
  };

  const getChatTitle = (session) => {
    const firstUserMsg = session.messages.find(m => m.user);
    if (firstUserMsg?.user) {
      return firstUserMsg.user.substring(0, 40) + (firstUserMsg.user.length > 40 ? '...' : '');
    }
    return 'New chat';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString();
  };

  setInterval(async () => {
    checkLogin();
  }, 5 * 60 * 1000);

  useEffect(() => {
    scrollableDivRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [navigate]);

  useEffect(() => {
    checkLogin();
  },[])

  useEffect(() => {
    loadChatSessions();
  },[id])

  useEffect(() => {
    if (!isFetching || !currentSessionId || !id) {
      return;
    }

    scrollableDivRef.current.scrollIntoView({ behavior: 'smooth' });

    console.log('Starting polling for response while fetching...');

    const initialDelay = setTimeout(() => {
      const responseFound = checkForResponseInLocalStorage(currentSessionId);
      if (responseFound) {
        return;
      }

      const pollInterval = setInterval(() => {
        const found = checkForResponseInLocalStorage(currentSessionId);
        if (found) {
          clearInterval(pollInterval);
        }
      }, 500);
      setTimeout(() => scrollToRef(scrollableDivRef), 100);
      return () => {
        clearInterval(pollInterval);
      };
    }, 300);

    return () => {
      clearTimeout(initialDelay);
    };
  }, [isFetching, currentSessionId, id, messages]);

  useEffect(() => {
    if (input_post && create_discussion ) {
      setShowOverlay(true);
      setCreateDiscussion(false);
    }
  }, [input_post, create_discussion, forum_title]);

  useEffect(() => {
    if (messages.length > 0) {
      const lastMsg = messages[messages.length - 1];

      if (lastMsg && lastMsg.bot && !lastMsg.isLoading && isFetching) {
        setIsFetching(false);
        localStorage.removeItem(`gemini_loading_${currentSessionId}_${id}`);
      }
    }
  }, [messages, isFetching, currentSessionId, id]);

    const handleSubmit = async (title, post, selectedTags = []) => {
      try {
        let login_data = await Konsensus_Constants._retrieveDataLocal("login_response");
        let AXIOS_CONFIG = {
          credentials: "include",
          headers: {
            'Accept': 'application/json',
            'Authorization': 'Token ' + login_data.login_response.data.token
          }
        }

        // Build tags data array from selected tag IDs
        const tagsData = selectedTags.map(tagId => ({
          type: "tags",
          id: tagId
        }));

        // If no tags selected, try to use General tag as fallback
        if (tagsData.length === 0) {
          const generalTag = Object.values(tags).find(t =>
            t.attributes?.name?.toLowerCase() === 'general'
          );
          tagsData.push({
            type: "tags",
            id: generalTag ? generalTag.id : "1"
          });
        }

        let response2 = await axios.post(Konsensus_Constants.FORUM_URL + '/api/discussions', {
          "data": {
            "type": "discussions",
            "attributes": {
              "title": title,
              "content": post
            },
            "relationships": {
              "tags": {
                "data": tagsData
              }
            }
          }
        }, AXIOS_CONFIG);

        navigate('/forum/' + response2.data.data.id);
      } catch (error) {
        console.error(error);
      }
    };

  const extractCodeBlocks = (text) => {
    const files = [];
    const codeBlockRegex = /```(\w+)\n([\s\S]*?)```/g;
    let match;

    while ((match = codeBlockRegex.exec(text)) !== null) {
      const language = match[1].toLowerCase();
      const code = match[2];

      if (code.trim().length > 0) {
        files.push(createFileFromCode(code, language));
      }
    }

    if (files.length === 0) {
      const htmlMatch = text.match(/<!DOCTYPE html>[\s\S]*?<\/html>/i);
      if (htmlMatch) {
        files.push(createFileFromCode(htmlMatch[0], 'html'));
      }

      const cssMatch = text.match(/[\s\S]*?\{[\s\S]*?\}/);
      if (cssMatch && (text.includes(':root') || text.includes('body {') || text.includes('.') || text.includes('#'))) {
        const cssContent = text.substring(text.indexOf('{'), text.lastIndexOf('}') + 1);
        if (cssContent.length > 50) {
          files.push(createFileFromCode(cssContent, 'css'));
        }
      }
    }

    return files;
  };

  const createFileFromCode = (code, language) => {
    let extension = 'txt';
    let filename = 'code';

    const extractedName = extractFilenameFromComment(code);
    if (extractedName) {
      const parts = extractedName.split('/');
      const file = parts[parts.length - 1];
      const [name, ext] = file.split('.');
      filename = name;
      extension = ext || language || 'txt';
    }else{
        if (language === 'html') {
          extension = 'html';
          filename = 'index';
        } else if (language === 'css') {
          extension = 'css';
          filename = 'style';
        } else if (language === 'bash') {
          extension = 'bash';
          filename = 'commandline';
        } else if (language === 'js' || language === 'jsx' || language === 'javascript') {
          extension = language === 'jsx' ? 'jsx' : 'js';
          const match = code.match(/^(?:import .*\n)*\s*(?:const\s+([A-Za-z_$][\w$]*)|function\s+([A-Za-z_$][\w$]*))/m);
          if (match) {
            filename = match[1] || match[2];
          } else {
            filename = language === 'jsx' ? 'component' : 'script';
          }
        } else if (language === 'python') {
          extension = 'py';
          filename = 'script';
        } else if (language === 'json') {
          extension = 'json';
          filename = 'data';
        }
    }

    const blob = new Blob([code], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);

    return {
      filename: `${filename}.${extension}`,
      originalname: `${filename}.${extension}`,
      url: url,
      size: blob.size,
      mimetype: 'text/plain',
      type: 'document',
      language: language
    };
  };

  const extractFilenameFromComment = (code) => {
    const firstLine = code.split('\n')[0].trim();
    const match = firstLine.match(/(?:\/\*|\/\/)\s*(.+\.\w+)\s*(?:\*\/)?/);
    if (match) {
      return match[1];
    }
    return null;
  };

  const sendMessage = async () => {
    try{
      console.log('=== SEND MESSAGE STARTED ===');
      setTimeout(() => scrollToRef(scrollableDivRef), 100);

      // Set loading immediately
      setIsFetching(true);

      // Save to localStorage synchronously
      if (currentSessionId && id) {
        localStorage.setItem(`gemini_loading_${currentSessionId}_${id}`, 'true');
        console.log('✓ Saved loading state to localStorage');
      }

      const userMessage = input;
      setInput('');

      // Create temp message IMMEDIATELY
      const tempMsg = {
        user: userMessage,
        bot: '',
        files: [],
        isLoading: true
      };

      const tempMessages = [...messages, tempMsg];
      setMessages(tempMessages);
      setRenderKey(prev => prev + 1);
      console.log('✓ Created temp loading message');
      setTimeout(() => scrollToRef(scrollableDivRef), 100);

      let fileUploadResponse = null;

      if (uploadedFiles.length > 0) {
        console.log('→ Uploading files...');
        try {
          fileUploadResponse = await uploadFilesToServer(uploadedFiles);

          if (fileUploadResponse && fileUploadResponse.files) {
            fileUploadResponse.files = fileUploadResponse.files.map(file => ({
              ...file,
              url: ensureHttps(file.url)
            }));
          }

          // Update with files
          const withFiles = [...messages, { ...tempMsg, files: fileUploadResponse.files }];
          setMessages(withFiles);
          console.log('✓ Updated message with files');

        } catch (error) {
          console.error('File upload failed:', error);
          const errorMsg = error.response?.data?.error || error.message || 'Unknown error';
          alert(`Failed to upload files: ${errorMsg}\nSending message without attachments.`);
        }
      }

      setUploadedFiles([]);

      // Save temp message to localStorage
      const finalTempMsg = {
        user: userMessage,
        bot: '',
        files: fileUploadResponse ? fileUploadResponse.files : [],
        isLoading: true
      };

      const finalTempMessages = [...messages, finalTempMsg];
      updateCurrentSession(finalTempMessages);
      console.log('✓ Saved temp message to localStorage');

      // API call
      console.log('→ Calling API...');
      let response = await axios.post(Konsensus_Constants.API_URL+'/api/chat2', {
        email: email,
        message: userMessage,
        sessionId: currentSessionId,
        temperature: 0.9,
        maxTokens: 2048,
        files: fileUploadResponse ? fileUploadResponse.files : []
      });

      console.log('✓ Got API response');

      const generatedCodeFiles = extractCodeBlocks(response.data.reply.text);

      let allFiles = [
        ...(response.data.files || response.data.reply.attachments || []),
        ...generatedCodeFiles
      ];

      allFiles = allFiles.map(file => ({
        ...file,
        url: ensureHttps(file.url)
      }));

      setInputPost(response.data.reply.text);
      setForumTitle("");

      const displayText = response.data.reply.text.replace(/```(\w+)?\n([\s\S]*?)```/g, (match, lang, code) => {
        const language = (lang || '').toLowerCase();

        if (['bash', 'sh', 'shell'].includes(language)) {
          return match;
        }

        if (!language) {
          return code;
        }

        const fileInfo = getFileInfo(code, language);
        const matchingFile = allFiles.find(f =>
          f.filename === `${fileInfo.filename}.${fileInfo.extension}`
        );

        if (matchingFile) {
          return `\n\n<span class="file-view-link" data-url="${ensureHttps(matchingFile.url)}" data-filename="${matchingFile.filename}" style="color: #00aaaf; text-decoration: underline; cursor: pointer; font-weight: 500;">📄 Generated file: ${fileInfo.filename}.${fileInfo.extension}</span>\n\n`;
        }

        return `\n\n📄 **Generated file:** ${fileInfo.filename}.${fileInfo.extension}\n\n`;
      });
      console.log(response);
      const finalMessage = {
        user: userMessage,
        bot: displayText,
        files: allFiles,
        searchResults: response.data.reply.searchResults || null,
        isLoading: false
      };

      // Get latest from localStorage
      let currentMessages;
      try {
        const savedSessions = localStorage.getItem('gemini_chat_sessions_'+id);
        if (savedSessions) {
          const sessions = JSON.parse(savedSessions);
          const currentSession = sessions.find(s => s.id === currentSessionId);
          if (currentSession && currentSession.messages) {
            currentMessages = currentSession.messages;
          } else {
            currentMessages = messages;
          }
        } else {
          currentMessages = messages;
        }
      } catch (error) {
        currentMessages = messages;
      }

      // Replace loading message
      const finalMessages = currentMessages.map((msg, idx) => {
        if (idx === currentMessages.length - 1 && msg.user === userMessage && msg.isLoading) {
          return finalMessage;
        }
        return msg;
      });

      console.log('✓ Updating with final message');

      setMessages(finalMessages);
      setIsFetching(false);
      setRenderKey(prev => prev + 1);

      updateCurrentSession(finalMessages);

      setTimeout(() => {
        const savedSessions = localStorage.getItem('gemini_chat_sessions_'+id);
        if (savedSessions) {
          const sessions = JSON.parse(savedSessions);
          const updatedSessions = sessions.map(session => {
            if (session.id === currentSessionId) {
              return {
                ...session,
                messages: finalMessages,
                lastMessage: finalMessages[finalMessages.length - 1]?.bot || finalMessages[finalMessages.length - 1]?.user || 'New chat',
                updatedAt: new Date().toISOString()
              };
            }
            return session;
          });

          localStorage.setItem('gemini_chat_sessions_'+id, JSON.stringify(updatedSessions));
          setChatSessions(updatedSessions);
          console.log('✓ Force saved to localStorage');
        }

        setTimeout(() => scrollToRef(scrollableDivRef), 100);
      }, 200);

      console.log('=== SEND MESSAGE COMPLETE ===');

    } catch (e) {
      console.error('Gemini chat error:', e);
      setIsFetching(false);
      localStorage.removeItem(`gemini_loading_${currentSessionId}_${id}`);
      alert('Failed to send message. Please try again.');
      }
    };

  useEffect(() => {
    const handleFileView = (e) => {
      if (e.target.classList.contains('file-view-link')) {
        const url = e.target.getAttribute('data-url');

        if (url) {
          window.open(url, '_blank', 'noopener,noreferrer');
        }
      }
    };

    document.addEventListener('click', handleFileView);

    return () => {
      document.removeEventListener('click', handleFileView);
    };
  }, []);

    const getFileInfo = (code, language) => {
      // Determine filename & extension without writing the file
      let extension = language || 'txt';
      let filename = 'code';

    const extractedName = extractFilenameFromComment(code);
    if (extractedName) {
      const parts = extractedName.split('/');
      const file = parts[parts.length - 1]; // get only the file name
      const [name, ext] = file.split('.');
      filename = name;
      extension = ext || language || 'txt';
    }else{
        if (language === 'html') {
          extension = 'html';
          filename = 'index';
        } else if (language === 'css') {
          extension = 'css';
          filename = 'style';
        } else if (language === 'bash') {
          extension = 'bash';
          filename = 'commandline';
        } else if (language === 'js') {
            extension = 'js';
            // Match first const or function declaration (ignoring imports)
            const match = code.match(/^(?:import .*\n)*\s*(?:const\s+([A-Za-z_$][\w$]*)|function\s+([A-Za-z_$][\w$]*))/m);
            if (match) {
              filename = match[1] || match[2]; // take const name or function name
            } else {
              filename = 'script';
            }
        } else if (language === 'jsx') {
          extension = 'jsx';
            // Match first const or function declaration (ignoring imports)
            const match = code.match(/^(?:import .*\n)*\s*(?:const\s+([A-Za-z_$][\w$]*)|function\s+([A-Za-z_$][\w$]*))/m);
            if (match) {
              filename = match[1] || match[2]; // take const name or function name
            } else {
              filename = 'component';
            }
        } else if (language === 'javascript' || language === 'js') {
            extension = 'js';
            // Match first const or function declaration (ignoring imports)
            const match = code.match(/^(?:import .*\n)*\s*(?:const\s+([A-Za-z_$][\w$]*)|function\s+([A-Za-z_$][\w$]*))/m);
            if (match) {
              filename = match[1] || match[2]; // take const name or function name
            } else {
              filename = 'script';
            }
        } else if (language === 'python') {
          extension = 'py';
          filename = 'script';
        } else if (language === 'json') {
          extension = 'json';
          filename = 'data';
        }
    }

      return { filename, extension };
    };

  let title = "";
  let body = "";

  const createDiscussion = () => {
    console.log(messages[messages.length - 1].bot);
    const parts = messages[messages.length - 1].bot.split('---');
    let addedNewLineSubject = false;
    let finalBody = "";
    if( parts.length===1 ){
      setInputPost(parts[0]);
      const parts2 = parts[0].split("\n");
      for( let i=0; i<parts2.length; i++ ){
          if( parts2[i] && parts2[i].includes("Subject:") ){
              const subject_parts = parts2[i].split("Subject:");
              if( subject_parts[1] ){
                 addedNewLineSubject = true;
                 if( subject_parts[1].includes("**") ){
                  let split3 = subject_parts[1].split("**");
                  if( split3[1]=="" && split3[0]!="" ){
                    setForumTitle(split3[0]);
                    title = split3[0];
                  }else{
                    setForumTitle(split3[1]);
                    title = split3[1];
                  }
                 }else{
                  setForumTitle(subject_parts[1]);
                  title = subject_parts[1];
                 }
              }else{
                 addedNewLineSubject = true;
                 setForumTitle(parts[i+1]);
                 title = parts[i+1];
              }
          }else{
              if( addedNewLineSubject ){
                  addedNewLineSubject = false;
              }
          }
          if( parts2[i] && parts2[i].includes("Discussion Topic:") ){
              const subject_parts = parts2[i].split("Discussion Topic: ");
              if( subject_parts[1] ){
                 if( subject_parts[1].includes("**") ){
                  let split3 = subject_parts[1].split("**");
                  setForumTitle(split3[0]);
                  title = split3[0];
                 }else{
                  setForumTitle(subject_parts[1]);
                  title = subject_parts[1];
                 }
                 addedNewLineSubject = true;
              }else{
                 addedNewLineSubject = true;
                 setForumTitle(parts[i+1]);
                 title = parts[i+1];
              }
          }
          if( parts2[i] && parts2[i].includes("**Subject**:") ){
              const subject_parts = parts2[i].split("**Subject**: ");
              if( subject_parts[1] ){
                  if( subject_parts[1].includes("**") ){
                   let split3 = subject_parts[1].split("**");
                   setForumTitle(split3[0]);
                   title = split3[0];
                  }else{
                   setForumTitle(subject_parts[1]);
                   title = subject_parts[1];
                  }
                  addedNewLineSubject = true;
              }else{
                 addedNewLineSubject = true;
                 setForumTitle(parts[i+1]);
                 title = parts[i+1];
              }
          }
          if( parts2[i] && parts2[i].includes("**Message**:") ){
              addedNewLineSubject = true;
          }
          if( parts2[i] && parts2[i].includes("Message:") ){
              addedNewLineSubject = true;
          }
          if( parts2[i] && parts2[i].includes("[Your Name]") ){
              let split3 = parts2[i].split("[Your Name]");
              parts2[i] = split3[0]+username+split3[1];
          }
          if( !addedNewLineSubject ){
              finalBody+=parts2[i]+"\n";
          }
      }
      finalBody = finalBody.replace(/\n/g, "<br />");
      body = finalBody;
      setInputPost(finalBody);
    }else{
      const parts2 = parts[1].split("\n");
      for( let i=0; i<parts2.length; i++ ){
          if( parts2[i] && parts2[i].includes("Subject:") ){
              const subject_parts = parts2[i].split("Subject:");
              if( subject_parts[1] ){
                 addedNewLineSubject = true;
                 if( subject_parts[1].includes("**") ){
                  let split3 = subject_parts[1].split("**");
                  if( split3[1]=="" && split3[0]!="" ){
                    setForumTitle(split3[0]);
                    title = split3[0];
                  }else{
                    setForumTitle(split3[1]);
                    title = split3[1];
                  }
                 }else{
                  setForumTitle(subject_parts[1]);
                  title = subject_parts[1];
                 }
              }else{
                 addedNewLineSubject = true;
                 setForumTitle(parts[i+1]);
                 title = parts[i+1];
              }
          }else{
              if( addedNewLineSubject ){
                  addedNewLineSubject = false;
              }
          }
          if( parts2[i] && parts2[i].includes("Discussion Topic:") ){
              const subject_parts = parts2[i].split("Discussion Topic: ");
              if( subject_parts[1] ){
                 if( subject_parts[1].includes("**") ){
                  let split3 = subject_parts[1].split("**");
                  setForumTitle(split3[0]);
                  title = split3[0];
                 }else{
                  setForumTitle(subject_parts[1]);
                  title = subject_parts[1];
                 }
                 addedNewLineSubject = true;
              }else{
                 addedNewLineSubject = true;
                 setForumTitle(parts[i+1]);
                 title = parts[i+1];
              }
          }
          if( parts2[i] && parts2[i].includes("**Subject**:") ){
              const subject_parts = parts2[i].split("**Subject**: ");
              if( subject_parts[1] ){
                  if( subject_parts[1].includes("**") ){
                   let split3 = subject_parts[1].split("**");
                   setForumTitle(split3[0]);
                   title = split3[0];
                  }else{
                   setForumTitle(subject_parts[1]);
                   title = subject_parts[1];
                  }
                  addedNewLineSubject = true;
              }else{
                 addedNewLineSubject = true;
                 setForumTitle(parts[i+1]);
                 title = parts[i+1];
              }
          }
          if( parts2[i] && parts2[i].includes("**Message**:") ){
              addedNewLineSubject = true;
          }
          if( parts2[i] && parts2[i].includes("Message:") ){
              addedNewLineSubject = true;
          }
          if( parts2[i] && parts2[i].includes("[Your Name]") ){
              let split3 = parts2[i].split("[Your Name]");
              parts2[i] = split3[0]+username+split3[1];
          }
          if( !addedNewLineSubject ){
              finalBody+=parts2[i]+"\n";
          }
      }
      finalBody = finalBody.replace(/\n/g, "<br />");
      body = finalBody;
      setInputPost(finalBody);
      console.log(title);
    }
    setCreateDiscussion(true);
  }

  var keys = {}
  const handleKeyPress = (event) => {
    let { keyCode, type } = event || Event;
    let isKeyDown = (type == 'keydown');
    keys[keyCode] = isKeyDown;

    if(isKeyDown && keys[13] && (keys[17] || keys[91] || keys[93])){
      sendMessage();
      console.log('user pressed ctrl or cmd and enter')
    }
  };

    // Add these camera functions
    const openCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'user' },
          audio: false
        });
        setCameraStream(stream);
        setCameraOpen(true);

        // Wait for next render cycle to ensure videoRef is available
        setTimeout(() => {
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
          }
        }, 100);
      } catch (error) {
        console.error('Camera access error:', error);
        alert('Unable to access camera. Please check permissions.');
      }
    };

    const closeCamera = () => {
      if (cameraStream) {
        cameraStream.getTracks().forEach(track => track.stop());
        setCameraStream(null);
      }
      setCameraOpen(false);
    };

    const capturePhoto = () => {
      if (!videoRef.current || !canvasRef.current) return;

      const video = videoRef.current;
      const canvas = canvasRef.current;
      const context = canvas.getContext('2d');

      // Set canvas dimensions to match video
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      // Draw video frame to canvas
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Convert canvas to blob
      canvas.toBlob((blob) => {
        const file = new File([blob], `camera_${Date.now()}.jpg`, { type: 'image/jpeg' });
        const newFile = {
          file: file,
          name: file.name,
          size: file.size,
          type: file.type,
          id: Math.random().toString(36).substr(2, 9)
        };

        setUploadedFiles([...uploadedFiles, newFile]);
        closeCamera();
      }, 'image/jpeg', 0.8);
    };


  function RawHTMLExample({ htmlString }) {
    let cleanHtml = DOMPurify.sanitize(he.decode(htmlString), {
      ALLOWED_TAGS: ['br', 'p', 'strong', 'em', 'b', 'i', 'u', 'a', 'span', 'div'],
      ALLOWED_ATTR: ['href', 'download', 'style', 'target', 'rel', 'class', 'data-url', 'data-filename']
    });
    cleanHtml = cleanHtml.replace(/\n/g, "<br />");
    return <div dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
  }

  return (
    <Box sx={{
                 height: "100%",
                 display: "flex",
                 flexDirection: "column",
               }}>
      {/* Chat History Drawer */}
      <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box sx={{ width: 300, p: 2 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 style={{ margin: 0 }}>Chat History</h3>
            <Button
              onClick={createNewChat}
              style={{
                backgroundColor: "#00aaaf",
                borderColor: "#00aaaf",
                fontSize: 12,
                padding: '4px 12px'
              }}
            >
              New Chat
            </Button>
          </div>

          {chatSessions.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 20, color: '#999' }}>
              <p>No saved chats yet</p>
              <p style={{ fontSize: 12 }}>Start a conversation to create your first chat</p>
            </div>
          ) : (
            <>
              <List>
                {chatSessions.map((session) => (
                  <ListItem
                    key={session.id}
                    disablePadding
                    secondaryAction={
                      <IconButton edge="end" onClick={() => deleteSession(session.id)} size="small">
                        <span style={{ fontSize: 18, color: '#ff4444' }}>×</span>
                      </IconButton>
                    }
                    sx={{
                      backgroundColor: session.id === currentSessionId ? '#e0f7f7' : 'transparent',
                      borderRadius: 1,
                      mb: 0.5
                    }}
                  >
                    <ListItemButton onClick={() => { loadSession(session.id); setDrawerOpen(false); }}>
                      <ListItemText
                        primary={getChatTitle(session)}
                        secondary={formatDate(session.updatedAt)}
                        primaryTypographyProps={{
                          style: { fontSize: 14, fontWeight: session.id === currentSessionId ? 600 : 400 }
                        }}
                        secondaryTypographyProps={{
                          style: { fontSize: 11 }
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>

              <Button
                onClick={clearAllHistory}
                style={{
                  backgroundColor: "#ff4444",
                  borderColor: "#ff4444",
                  fontSize: 12,
                  padding: '6px 12px',
                  width: '100%',
                  marginTop: 16
                }}
              >
                Clear All History
              </Button>
            </>
          )}
        </Box>
      </Drawer>

      {/* Delete Chat Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <div style={{ padding: 24, minWidth: 300 }}>
          <h3 style={{ margin: '0 0 16px 0', color: '#00aaaf' }}>Delete Chat</h3>
          <p style={{ margin: '0 0 24px 0' }}>Are you sure you want to delete this chat?</p>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <Button
              onClick={() => setDeleteDialogOpen(false)}
              style={{ backgroundColor: '#ccc', borderColor: '#ccc' }}
            >
              Cancel
            </Button>
            <Button
              onClick={confirmDeleteSession}
              style={{ backgroundColor: '#ff4444', borderColor: '#ff4444' }}
            >
              Delete
            </Button>
          </div>
        </div>
      </Dialog>

      {/* Clear All History Confirmation Dialog */}
      <Dialog open={clearAllDialogOpen} onClose={() => setClearAllDialogOpen(false)}>
        <div style={{ padding: 24, minWidth: 300 }}>
          <h3 style={{ margin: '0 0 16px 0', color: '#00aaaf' }}>Clear All Chats</h3>
          <p style={{ margin: '0 0 24px 0' }}>Are you sure you want to delete all chat history?</p>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <Button
              onClick={() => setClearAllDialogOpen(false)}
              style={{ backgroundColor: '#ccc', borderColor: '#ccc' }}
            >
              Cancel
            </Button>
            <Button
              onClick={confirmClearAllHistory}
              style={{ backgroundColor: '#ff4444', borderColor: '#ff4444' }}
            >
              Clear All
            </Button>
          </div>
        </div>
      </Dialog>

      {showAlert && (
        <div>
         <div
            style={{
              position: "fixed",
              top: 0, left: 0, right: 0, bottom: 0,
              background: "rgba(0,0,0,0.4)",
              zIndex: 999
            }}
          />
            <div style={{
              background: "#fff", color: "#00aaaf", border: "2px solid #00aaaf",
              borderRadius: 4, padding: 16, width: 300, margin: "2em auto",
              position: "fixed", left: 0, right: 0, top: "40%", zIndex: 1000
            }}>
              <p>Are you sure you wish to create conversation?</p>
              <button onClick={()=>{setShowOverlay(true); setShowAlert(false);}} style={{marginRight:8}}>Yes</button>
              <button onClick={()=>{setShowAlert(false)}}>No</button>
            </div>
          </div>
      )}
      {showOverlay && (
      <AddForumOverlay
        handleSubmit={handleSubmit}
        onClose={() => setShowOverlay(false)}
        input_post={input_post!="" ? input_post : body}
        forum_title={forum_title!="" ? forum_title : title}
        tags={forum_tags}
        open={showOverlay}
      />
      )}
     <Paper elevation={3} sx={{ p: 2 }}>
         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
           <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
             <Button
               onClick={() => setDrawerOpen(true)}
               style={{
                 backgroundColor: "#00aaaf",
                 borderColor: "#00aaaf",
                 fontSize: 12,
                 padding: '6px 12px',
                 minWidth: 'auto'
               }}
             >
               ☰
             </Button>
             <img src={require('../assets/images/banner.png')}
                           style={{
                              height: 97,
                              width: 380,
                              marginBottom: 0,
                              marginTop: 20,
                           }}/>
           </div>
           <div style={{ display: 'flex', gap: 8 }}>
             <Button
               onClick={createNewChat}
               style={{
                 backgroundColor: "#00aaaf",
                 borderColor: "#00aaaf",
                 fontSize: 12,
                 padding: '6px 12px'
               }}
             >
               + New Chat
             </Button>
             <Button
               onClick={createDiscussion}
               style={{
                 backgroundColor: "#00aaaf",
                 borderColor: "#00aaaf",
                 fontSize: 12,
                 padding: '6px 12px'
               }}
             >
               + Create Discussion
             </Button>
           </div>
         </div>
     </Paper>
      <Paper elevation={3}
                     sx={{
                       width: "100%",
                       p: 2,
                       height: "65%",
                     }}>
            {isLoadingHistory && (
              <div style={{ textAlign: 'center', padding: 20 }}>
                <CircularProgress sx={{ color: '#00aaaf' }} />
                <p>Loading chat history...</p>
              </div>
            )}
            <div id="chat-div" ref={scrollableDivRef} className="chat-div" key={renderKey}>
              {messages.map((msg, idx) => (
                <div key={idx}>
                  {(msg.user && msg.user!="") || (msg.files && msg.files.length > 0) ? (
                      <div>
                        {msg.user && msg.user !== "" && (
                            <p><strong>You:</strong> {msg.user}</p>
                        )}
                        {msg.files && msg.files.length > 0 && (
                        <div style={{ marginLeft: 20, marginBottom: 10 }}>
                          {msg.files.map((file, fIdx) => (
                            <div key={fIdx} style={{
                              marginBottom: 8
                            }}>
                              {file.type === 'image' || (file.mimetype && file.mimetype.startsWith('image/')) ? (
                                <div style={{
                                  marginBottom: 8,
                                  maxWidth: 300
                                }}>
                                  <a href={file.url} target="_blank" rel="noopener noreferrer">
                                    <img
                                      src={file.url}
                                      alt={file.originalname || file.name}
                                      style={{
                                        maxWidth: '100%',
                                        maxHeight: 200,
                                        borderRadius: 8,
                                        border: '1px solid #e0e0e0',
                                        cursor: 'pointer'
                                      }}
                                    />
                                  </a>
                                  <div style={{ fontSize: 11, color: '#666', marginTop: 4 }}>
                                    {file.originalname || file.name} ({formatFileSize(file.size)})
                                  </div>
                                </div>
                              ) : (
                                <a
                                  href={file.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    textDecoration: 'none',
                                    display: 'inline-block'
                                  }}
                                >
                                  <div style={{
                                    fontSize: 12,
                                    color: '#00aaaf',
                                    backgroundColor: '#f0f0f0',
                                    padding: '6px 10px',
                                    borderRadius: 4,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    cursor: 'pointer',
                                    border: '1px solid #e0e0e0'
                                  }}>
                                    📄 {file.originalname || file.name} ({formatFileSize(file.size)})
                                  </div>
                                </a>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : null}
                  <div style={{ paddingBottom: 10 }}>
                    <strong>Konsensus:</strong>{" "}
                    {/* Show loading if message is marked as loading OR if it has user but no bot response */}
                    {(msg.isLoading === true || (msg.user && !msg.bot)) ? (
                      <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 8 }}>
                        <CircularProgress size={16} sx={{ color: '#00aaaf' }} />
                        <span style={{ marginLeft: 8, color: '#666', fontSize: 14 }}>Thinking...</span>
                      </div>
                    ) : msg.bot ? (
                      <RawHTMLExample htmlString={msg.bot || ""} />
                    ) : null}
                     {/* Search Results Display */}
                     {msg.searchResults && msg.searchResults.sources && msg.searchResults.sources.length > 0 && (
                       <div style={{
                         marginTop: 16,
                         padding: 12,
                         backgroundColor: '#f0f9f9',
                         borderRadius: 6,
                         border: '1px solid #00aaaf20'
                       }}>
                         {/* Sources Header */}
                         <div style={{
                           fontSize: 13,
                           fontWeight: 600,
                           color: '#00aaaf',
                           marginBottom: 12
                         }}>
                           📚 Sources ({msg.searchResults.totalResults}):
                         </div>

                         {msg.searchResults.sources.map((source, srcIdx) => (
                           <div key={srcIdx} style={{ marginBottom: 20 }}>
                             {/* Source Title Link */}
                             <a
                               href={source.signedUrl || source.link}
                               target="_blank"
                               rel="noopener noreferrer"
                               style={{
                                 fontSize: 13,
                                 fontWeight: 600,
                                 color: '#00aaaf',
                                 textDecoration: 'none',
                                 display: 'flex',
                                 alignItems: 'center',
                                 gap: 6,
                                 padding: '6px 0',
                                 cursor: 'pointer',
                                 marginBottom: 8
                               }}
                               onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'}
                               onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}
                             >
                               <span>📄</span>
                               <span style={{ flex: 1 }}>{source.title}</span>
                               {source.pageNumber && (
                                 <span style={{ fontSize: 11, color: '#666' }}>
                                   Page {source.pageNumber}
                                 </span>
                               )}
                               <span style={{ fontSize: 11, color: '#999' }}>↗</span>
                             </a>

                             {/* Snippet */}
                             {/*source.snippet && (
                               <div style={{
                                 fontSize: 12,
                                 color: '#555',
                                 backgroundColor: '#fff',
                                 padding: 8,
                                 borderRadius: 4,
                                 marginBottom: 8,
                                 borderLeft: '3px solid #00aaaf',
                                 fontStyle: 'italic'
                               }}
                               dangerouslySetInnerHTML={{
                                 __html: DOMPurify.sanitize(source.snippet)
                               }}
                               />
                             )*/}

                             {/* Extractive Answers - REMOVED per Deon's request
                             {source.extractiveAnswers && source.extractiveAnswers.length > 0 && (
                               <div style={{
                                 backgroundColor: '#fffbf0',
                                 border: '1px solid #ffd70020',
                                 borderLeft: '4px solid #ffd700',
                                 borderRadius: 6,
                                 padding: 10,
                                 marginBottom: 8
                               }}>
                                 <div style={{
                                   fontSize: 11,
                                   fontWeight: 600,
                                   color: '#d4a017',
                                   marginBottom: 8,
                                   textTransform: 'uppercase',
                                   letterSpacing: '0.5px'
                                 }}>
                                   💡 Key Points
                                 </div>
                                 {source.extractiveAnswers.map((answer, ansIdx) => (
                                   <div key={ansIdx} style={{
                                     fontSize: 12,
                                     lineHeight: '1.6',
                                     color: '#555',
                                     marginBottom: ansIdx < source.extractiveAnswers.length - 1 ? 8 : 0,
                                     paddingLeft: 8
                                   }}>
                                     <span style={{ color: '#d4a017', marginRight: 8 }}>•</span>
                                     {answer.content}
                                     {answer.pageNumber && (
                                       <span style={{
                                         fontSize: 10,
                                         color: '#999',
                                         marginLeft: 6
                                       }}>
                                         (p. {answer.pageNumber})
                                       </span>
                                     )}
                                   </div>
                                 ))}
                               </div>
                             )}

                             {/* Extractive Segments */}
                             {/*source.extractiveSegments && source.extractiveSegments.length > 0 && (
                               <div>
                                 {source.extractiveSegments.map((segment, segIdx) => (
                                   <div key={segIdx} style={{
                                     backgroundColor: '#fff',
                                     border: '1px solid #e0e0e0',
                                     borderRadius: 6,
                                     padding: 12,
                                     marginBottom: 8,
                                     fontSize: 12,
                                     lineHeight: '1.7',
                                     color: '#333'
                                   }}>
                                     {segment.pageNumber && (
                                       <div style={{
                                         fontSize: 10,
                                         color: '#00aaaf',
                                         fontWeight: 600,
                                         marginBottom: 8,
                                         textTransform: 'uppercase',
                                         letterSpacing: '0.5px'
                                       }}>
                                         Page {segment.pageNumber}
                                       </div>
                                     )}
                                     <div style={{ whiteSpace: 'pre-wrap' }}>
                                       {segment.content}
                                     </div>
                                   </div>
                                 ))}
                               </div>
                             )*/}
                           </div>
                         ))}
                       </div>
                     )}
                  </div>
                </div>
              ))}
            </div>
      </Paper>
      <Paper elevation={3}
                     sx={{
                       flex: 1,
                       width: "100%",
                       p: 2,
                     }}>
        <div className="chat-input-div">
        {/* Camera Modal */}
        <Modal show={cameraOpen} onHide={closeCamera} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Capture Photo</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: 0, backgroundColor: '#000' }}>
            <div style={{ position: 'relative', width: '100%', paddingBottom: '75%' }}>
              <video
                ref={videoRef}
                autoPlay
                playsInline
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
              <canvas ref={canvasRef} style={{ display: 'none' }} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeCamera}>
              Cancel
            </Button>
            <Button
              onClick={capturePhoto}
              style={{ backgroundColor: "#00aaaf", borderColor: "#00aaaf" }}
            >
              📷 Capture
            </Button>
          </Modal.Footer>
        </Modal>
          {/* File Upload Preview */}
          {uploadedFiles.length > 0 && (
            <div style={{
              marginBottom: 12,
              padding: 8,
              backgroundColor: '#f9f9f9',
              borderRadius: 4,
              border: '1px solid #e0e0e0'
            }}>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 8, fontWeight: 600 }}>
                Attached files ({uploadedFiles.length}):
              </div>
              {uploadedFiles.map((fileObj) => (
                <div key={fileObj.id} style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '6px 8px',
                  backgroundColor: '#fff',
                  borderRadius: 4,
                  marginBottom: 4,
                  border: '1px solid #e0e0e0'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1 }}>
                    <span style={{ fontSize: 16 }}>📎</span>
                    <div style={{ fontSize: 13 }}>
                      <div style={{ fontWeight: 500 }}>{fileObj.name}</div>
                      <div style={{ fontSize: 11, color: '#999' }}>
                        {formatFileSize(fileObj.size)} • {fileObj.type || 'Unknown type'}
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => removeFile(fileObj.id)}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#ff4444',
                      fontSize: 18,
                      cursor: 'pointer',
                      padding: '0 8px'
                    }}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}

          <div style={{width:100+"%"}}>
          <div style={{display: 'flex', alignItems: 'flex-end', gap: 8}}>
              {/* Camera Button */}
              <Button
                onClick={openCamera}
                disabled={isFetching}
                style={{
                  backgroundColor: "#00aaaf",
                  borderColor: "#00aaaf",
                  minWidth: 'auto',
                  padding: '8px 12px',
                  fontSize: 16,
                  marginBottom: 10,
                  color: "#fff",
                }}
                title="Take photo"
              >
                <CameraAltIcon style={{ color: '#fff', fontSize: 18 }} />
              </Button>
            {/* File Upload Button */}
            <input
              ref={fileInputRef}
              type="file"
              multiple
              onChange={handleFileSelect}
              style={{ display: 'none' }}
              accept=".pdf,.doc,.docx,.txt,.xls,.xlsx,.csv,.jpg,.jpeg,.png,.gif"
            />
            <Button
              onClick={() => fileInputRef.current?.click()}
              disabled={isFetching}
              style={{
                backgroundColor: "#00aaaf",
                borderColor: "#00aaaf",
                minWidth: 'auto',
                padding: '8px 12px',
                fontSize: 16,
                marginBottom: 10,
                color: "#fff",
              }}
              title="Attach files"
            >
              <AttachFileIcon style={{ color: '#fff', fontSize: 18 }} />
            </Button>

            <textarea
              placeholder="Type message"
              className="input-rounded"
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKeyPress}
              onSubmit={sendMessage}
              style={{flex: 1}}
            />

            {isFetching ? (
              <div><CircularProgress sx={{ color: '#00aaaf' }} style={{width:40, height:40,marginBottom: 10,}}/></div>
            ) : (
              <div><Button onClick={sendMessage} style={{               backgroundColor: "#00aaaf",
                                                                            borderColor: "#00aaaf",
                                                                            fontSize: 12,
                                                                            padding: '6px 12px',backgroundColor: "#00aaaf", borderColor: "#00aaaf",marginBottom: 10,}} className="chat-rounded2">Send</Button></div>
            )}
          </div>
          </div>
        </div>
      </Paper>
      <BottomTabNavigation />
    </Box>
  );
}